<template>
  <div>
    <q-card class="backup-dialog-container">
      <q-card-section class="row items-center dialog-title-wrapper">
        <div class="ibf-h2 title">{{ template.dialogTitle }}</div>
      </q-card-section>
      <q-card-section class="row items-center dialog-body-wrapper">
        <h6 class="ibf-h6 app_text_grey">{{ template.body }}</h6>
      </q-card-section>
      <q-card-actions
        class="action-wrapper"
        align="center"
      >
        <q-btn
          v-if="template.cancelLabel"
          v-close-popup
          class="dialog-btn cancel-btn incredi-button-ibx ibf-h9"
          :label="template.cancelLabel"
          no-caps
          flat
          rounded
          @click="cancelClicked"
        />
        <q-btn
          v-if="template.okLabel"
          v-close-popup
          class="dialog-btn ok-btn incredi-button-ibx ibf-h9"
          :label="template.okLabel"
          no-caps
          flat
          rounded
          @click="okClicked"
        />
      </q-card-actions>
      <div class="bottom-gradient warning">
        <div class="bottom-gradient1"></div>
        <div class="bottom-gradient2"></div>
      </div>
    </q-card>
  </div>
</template>

<script>
export default {
  name: 'BackupDialog',
  props: {
    template: {
      type: Object,
      validator(template) {
        const rules = val => val === undefined || typeof val === 'string';
        const okLabel = rules(template.okLabel);
        const cancelLabel = rules(template.cancelLabel);
        const title = rules(template.dialogTitle);
        const body = rules(template.body);
        return okLabel && cancelLabel && title && body;
      },
    },
    cancelCallback: {
      type: Function,
    },
    okCallback: {
      type: Function,
    },
  },
  methods: {
    cancelClicked() {
      if (this.cancelCallback) this.cancelCallback();
      else this.$emit('cancel');
    },
    okClicked() {
      if (this.okCallback) this.okCallback();
      else this.$emit('ok');
    },
  },
};
</script>

<style lang="scss" scoped>
.backup-dialog-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
}
h2,
h6 {
  line-height: 25px;
  margin: 0;
  text-align: center;
  width: 100%;
}
.dialog-title-wrapper {
  padding-top: 40px;
  padding-bottom: 5px;
  & .ibf-h2 {
    width: 100%;
    text-align: center;
  }
}
.dialog-body-wrapper {
  padding-top: 0;
}
.dialog-btn {
  min-width: 100px;
}
.bottom-gradient {
  position: absolute;
  bottom: 0;
  left: 0%;
  height: 24px;
  width: 100%;
}
.bottom-gradient1 {
  position: absolute;
  height: 24px;
  left: 0%;
  right: -0.23%;
  bottom: 0px;

  background: linear-gradient(90deg, rgba(0, 240, 185, 0.859375) -3.46%, #00f0b9 10.68%, rgba(0, 240, 185, 0) 50.87%);
  opacity: 0.5;
}

.bottom-gradient2 {
  position: absolute;
  height: 17px;
  left: 0%;
  right: 0%;
  bottom: -1px;

  background: linear-gradient(70.93deg, #0bece2 26.54%, #03e8b4 67.13%);
  opacity: 0.8;
}

.ok-btn {
  background-color: $-system-app-grey-22;
  color: $-system-app-white;
}
.cancel-btn {
  color: $-system-app-grey-22;
}

.warning .bottom-gradient1 {
  background: linear-gradient(90deg, #fff5d1 -3.46%, #ffe895 10.68%, #fff5d1 50.87%);
}

.warning .bottom-gradient2 {
  background: linear-gradient(70.93deg, #ffd02b 26.54%, #fff5d1 67.13%);
}

.warning .primary-strong {
  background-color: $-brand-yellow;
}
.warning .secondary {
  color: $-brand-yellow;
}

.failure.incredi-button-ibx.primary-strong {
  background-color: $-system-app-grey-22;
}
.failure.incredi-button-ibx.secondary {
  color: $-system-app-grey-22;
}

.primary-strong.disabled,
.danger .primary-strong.disabled,
.warning .primary-strong.disabled {
  background-color: $-status-status-offline;
}

.action-wrapper {
  align-items: flex-end;
  flex-grow: 1;
  display: flex;
  margin-bottom: 40px;
  width: 100%;
}
</style>
